export const sportHistory = {
  title: 'Filtro',
  submit: 'Aceptar filtro',
  all: 'Todo',
  event: 'Evento',
  region: 'País/Región',
  tournament: 'Torneo',
  sport: 'Deporte',
  outcome: 'Resultado',
  coef: 'Coeficiente',
  score: 'Puntuación final',
  count: 'Registros',
  noItems: 'No hay artículos',
  from: 'Fecha de',
  to: 'Fecha hasta',
  userId: 'ID de usuario',
  username: 'Nombre de Usuario',
  couponId: 'ID de cupón',
  itemsOnPage: 'Elementos en la página',
  player: 'Jugador',
  status: {
    title: 'Resultado',
    ACCEPTED: 'Pendiente',
    CASHED_OUT: 'Cashout',
    RETURNED: 'Devuelto',
    LOST: 'Perdido',
    WON: 'Ganado',
    HALF_RETURN: 'Mitad reembolsada',
    HALF_WIN: 'Mitad ganada',
    INITIAL_RETURN: 'Reembolso inicial',
    INITIAL_HALF_RETURN: 'Mitad inicial reembolsada',
    INITIAL_HALF_WON: 'Mitad inicial ganada',
    NOT_RESULTED: 'Pendiente'
  },
  type: {
    title: 'Tipo',
    express: 'Combinada',
    single: 'Simple',
  },
  eventType: {
    title: 'Tipo de evento',
    live: 'Vivir',
    offline: 'Desconectado',
  },
  headers: {
    betId: 'Id de Apuesta',
    userId: 'Id de Usuario',
    createdAt: 'Fecha',
    type: 'Tipo',
    provider: 'Proveedor',
    amount: 'Cantidad',
    currency: 'Moneda',
    coef: 'Coeficiente General',
    possibleWinAmount: 'Posibles Ganancias',
    status: 'Resultado',
    username: 'Nombre de Usuario'
  },
};
